module.exports = __webpack_public_path__ + "static/media/button-loader.6d9b8fb2.svg";